const styles = {
  container: {
    maxWidth: '1280px',
    margin: '0 auto 70px'
  },
  spinner: {
    margin: '100px auto'
  }
}

export default styles
